import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Card,
  CardContent,
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
  Button,
} from '@mui/material';
import { ArrowForward as ArrowIcon } from '@mui/icons-material';
import { formatRelativeDate, getActivityIcon, getActivityTypeName, formatInstagramHandle } from '../../utils/helpers';

const RecentActivityCard = ({ activities = [] }) => {
  const navigate = useNavigate();

  return (
    <Card sx={{ height: '100%' }}>
      <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
          <Typography variant="subtitle2" fontWeight={600}>
            Recent Activity
          </Typography>
          <Button
            size="small"
            endIcon={<ArrowIcon sx={{ fontSize: 14 }} />}
            onClick={() => navigate('/leads')}
            sx={{ fontSize: '0.7rem', py: 0.25 }}
          >
            View All
          </Button>
        </Box>

        {activities.length === 0 ? (
          <Box sx={{ textAlign: 'center', py: 2 }}>
            <Typography variant="caption" color="text.secondary">
              No recent activity
            </Typography>
          </Box>
        ) : (
          <List disablePadding>
            {activities.map((activity, index) => (
              <ListItem
                key={activity._id || index}
                sx={{
                  px: 0.75,
                  py: 0.5,
                  borderRadius: 0.5,
                  '&:hover': { bgcolor: 'grey.50' },
                  cursor: 'pointer',
                }}
                onClick={() => activity.lead?._id && navigate(`/leads/${activity.lead._id}`)}
              >
                <ListItemAvatar sx={{ minWidth: 36 }}>
                  <Avatar
                    sx={{
                      width: 28,
                      height: 28,
                      fontSize: '0.875rem',
                      bgcolor: 'grey.100',
                    }}
                  >
                    {getActivityIcon(activity.type)}
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
                      <Typography variant="caption" fontWeight={600} sx={{ fontSize: '0.8rem' }}>
                        {getActivityTypeName(activity.type)}
                      </Typography>
                      {activity.lead && (
                        <Typography variant="caption" color="primary.main" sx={{ fontSize: '0.8rem' }}>
                          {formatInstagramHandle(activity.lead.instagramHandle)}
                        </Typography>
                      )}
                    </Box>
                  }
                  secondary={
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <Typography variant="caption" color="text.secondary" sx={{ flex: 1, fontSize: '0.75rem' }}>
                        {activity.description || activity.lead?.businessName}
                      </Typography>
                      <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.75rem' }}>
                        {formatRelativeDate(activity.createdAt)}
                      </Typography>
                    </Box>
                  }
                />
              </ListItem>
            ))}
          </List>
        )}
      </CardContent>
    </Card>
  );
};

export default RecentActivityCard;
